import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ModalOverlayService {
  private readonly _hasBlockingOverlay = signal(false);
  hasBlockingOverlay = this._hasBlockingOverlay.asReadonly();

  setBlockingOverlay(open: boolean) {
    this._hasBlockingOverlay.set(open);
  }
}
